import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.css']
})
export class InformesComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
